import { render, staticRenderFns } from "./SchemaUpdateComponent.vue?vue&type=template&id=77259e28"
import script from "./SchemaUpdateComponent.vue?vue&type=script&lang=ts"
export * from "./SchemaUpdateComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports